import { StreamingArrayLoaderGetItemsRequest } from "hoksource";
import { Entity } from "../models/entities/entities/entity";
import { DirectoryComponent } from "../directory-shared/DirectoryComponent";
import { Item } from "../models/entities/items/item";
import { EntityItemLedgerEntryService } from "./EntityItemLedgerEntryService";
import { ItemLedgerEntry } from "../models/entities/entities/item-ledger-entry";
import { stringOrNullIfNumber } from "../functions/stringOrNullIfNumber";

export class EntityItemLedgerEntriesHomeController extends DirectoryComponent<any,{

    // entityGroup?:EntityGroup,
    orderType?:string;
    entity?:Entity,
    item?:Item,
    // lowInventoryOnly?:boolean
}>
{


    constructor(props)
    {
        super(props);
        this.state = {

        };
    }
    

    takeCount = 30;

    
    getItems = (filter:
        StreamingArrayLoaderGetItemsRequest<ItemLedgerEntry>
     )=>{

        var service = new EntityItemLedgerEntryService(this.http);
        return service.getList({
            skip : filter.currentIndex,
            take : this.takeCount,


            entityId:stringOrNullIfNumber(this.state.entity?.id),
            itemId:this.state.item?.id,
            orderType: this.state.orderType
        });
    }


}